<template lang="pug">
div
  v-row
    v-col
      data-wrapper(
        :loading="loading"
        :skeleton-items-count="imagesPerView"
        :has-items="!!cardsValues.length"
        skeleton-type="image"
      )
        template(#no-data)
          .text-center(v-if="!readOnly")
            v-btn(large color="primary" @click="pickAvatar" outlined).mx-auto Добавить изображение
        template(#default)
          the-flicking(
            :options=`{
              bound: true,
              align: 'prev',
              preventClickOnDrag: false,
              interruptable: false,
              panelsPerView: imagesPerView,
            }`
            @select="openFullView"
          )
            v-col(
              v-for="(item, idx) in cardsValues"
              :key="idx"
              xl=3 md=4 sm=6 cols=12
            )
              v-hover(v-slot="{ hover }")
                v-img.overflow-visible(
                  :src="item.avatar.value.url"
                  :aspect-ratio="16/9"
                )
                  v-btn.btn-remove(
                    v-if="hover && !readOnly"
                    color="error darken-1"
                    depressed
                    small
                    fab style="position: absolute; right: -10px; top: -10px; hover"
                    @click.prevent.stop.capture="removeCard(idx)"
                  ): v-icon mdi-delete

          .text-center(v-if="!readOnly")
              v-btn(color="primary" @click="pickAvatar" outlined).mx-auto Добавить изображение
  portal(to="image.dialog" v-slot="{ close, attrs }")
    v-img(:src="attrs.image")
</template>

<script>
import TheFlicking from '@/components/TheFlicking.vue';
import DataWrapper from '@/components/DataWrapper.vue';
import ConstructorCard from '@/models/list/ConstructorCard';

export default {
  components: {
    TheFlicking,
    DataWrapper,
  },
  props: {
    readOnly: { type: Boolean, default: false },
    cardsValues: { type: Array, default: null },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      props: {
        group: true,
        'leave-absolute': true,
      },
    };
  },
  computed: {
    imagesPerView() {
      const { $vuetify } = this;
      switch ($vuetify.breakpoint.name) {
        case 'xs': return 1;
        case 'sm': return 2;
        case 'md': return 3;
        case 'lg': return 3;
        case 'xl': return 4;
        default: return 1;
      }
    },
  },
  methods: {
    openFullView(t) {
      this.$modals.show('dialog-portal', {
        inputValue: 'image',
        image: this.cardsValues[t.index].avatar.value.url,
      });
    },

    removeCard(positionIdx) {
      const cards = [...this.cardsValues];
      cards.splice(positionIdx, 1);
      this.$emit('update:cards', cards);
      this.$modals.close();
    },
    pickAvatar() {
      this.$modals.show('pick-avatar', {
        onlyImage: true,
        input: (avatar) => {
          this.$emit('update:cards', [
            ...this.cardsValues,
            new ConstructorCard({
              type: 7,
              avatar,
            }),
          ]);
        },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-remove {
      opacity: .5;
      transition: all .2s;

    &:hover {
      opacity: 1;
    }
}
</style>
